import React from "react";
import { Modal } from "antd";
import { FileTextOutlined, ExclamationCircleOutlined } from "@ant-design/icons";

import * as S from "./style";
import DSButton from "../../components/DSButton";
import ModalDetailFinalize from "../../pages/home/modals/modalDetailFinalize";
import { PendingTicketInfoModalProps, FinishTicketParams } from "./types";
import { usePendingTicketInfoModal } from "./usePendingTicketInfoModal";
import { TicketTable } from "./TicketTable"; // <--- Importando a nova tabela
import { useAttendanceLimit } from "../../hooks/useAttendanceLimit";

export function PendingTicketInfoModal(props: PendingTicketInfoModalProps) {
  const { onClose, clientName } = props;
  const { checkLimit, LimitModal } = useAttendanceLimit();

  const {
    internalTicketsList,
    handleCreateGlobal,
    isClassificationModalOpen,
    setIsClassificationModalOpen,
    selectedTicketId,
    shouldCreateNewAfterFinish,
    handleContinue,
    handleFinishAndCreateNew,
    handleInternalFinish,
    handleOpenFinishOnly,
    loadingAction,
    isBusy,
  } = usePendingTicketInfoModal(props);

  const onGlobalCreateClick = async () => {
    const canAttend = await checkLimit();
    if (!canAttend) return; 

    handleCreateGlobal(); 
  };

  return (
    <>
      <Modal
        title={
          <span>
            <FileTextOutlined style={{ marginRight: 8, color: "#d4380d" }} />
            Atendimentos em Aberto
          </span>
        }
        open
        onCancel={onClose}
        destroyOnClose
        footer={null}
        width={900}
        wrapProps={{ "data-testid": "modal_atendimentos_abertos" }}
      >
        <S.AlertWrapper>
          <ExclamationCircleOutlined style={{ color: "#faad14", fontSize: "18px" }} />
          <S.AlertText>
            {internalTicketsList.length === 1 ? 'Existe' : 'Existem'}{' '}
            <strong> {internalTicketsList.length}{' '}
            {internalTicketsList.length === 1 ? 'protocolo' : 'protocolos'}
            </strong>{' '} em aberto para <strong>{clientName}</strong>.
          </S.AlertText>
        </S.AlertWrapper>

        <TicketTable 
          ticketsList={internalTicketsList}
          loadingAction={loadingAction}
          isBusy={isBusy}
          onContinue={handleContinue}
          onFinishAndCreate={handleFinishAndCreateNew}
          onFinishOnly={handleOpenFinishOnly}
        />

        <S.FooterWrapper>
          <DSButton
            buttonText="Criar Novo Protocolo"
            onClick={onGlobalCreateClick}
            className="btn-create-global"
            disabled={isBusy}
            isLoading={loadingAction === 'global_create'}
            dataTestId="btn_criar_novo_protocolo"
          />
        </S.FooterWrapper>
      </Modal>

      {isClassificationModalOpen && (
        <ModalDetailFinalize
          closeModal={() => setIsClassificationModalOpen(false)}
          customFinishFn={(params: FinishTicketParams) => {
            if (selectedTicketId !== null) {
              handleInternalFinish(params, selectedTicketId, shouldCreateNewAfterFinish);
            }
          }}
        />
      )}
      <LimitModal />
    </>
  );
}